import { uniq } from 'lodash-es'

export function useArticleFilters(widgetId: string) {
  const route = useRoute()

  type Param = 'tags' | 'page'

  const prefix = (param: Param) => `${widgetId}_${param}`

  const getParam = (param: Param) => route.query[prefix(param)]

  const page = computed(() => {
    const pageParam = Number(getParam('page'))
    if (isNaN(pageParam)) return 1
    return pageParam
  })

  const selectedTags = computed(() => {
    const tags = getParam('tags')
    if (typeof tags === 'string') return [tags]
    if (Array.isArray(tags)) return tags.filter(Boolean) as string[]
    return []
  })

  const getTagsLink = (newTags: string[]) => ({
    query: {
      ...route.query,
      [prefix('page')]: undefined,
      [prefix('tags')]: newTags
    }
  })

  function getPageLink(newPage: number) {
    return {
      query: {
        ...route.query,
        [prefix('page')]: newPage
      }
    }
  }

  const clearSelectedTagsLink = computed(() => getTagsLink([]))

  const getSelectTagLink = (tagId: string) =>
    getTagsLink(uniq([...selectedTags.value, tagId]))

  const getRemoveTagLink = (toRemove: string) =>
    getTagsLink(selectedTags.value.filter(tagId => tagId !== toRemove))

  const nextPageLink = computed(() => getPageLink(page.value + 1))
  const previousPageLink = computed(() => getPageLink(page.value - 1))

  const areFiltersActive = computed(() => !!selectedTags.value.length)

  return {
    page,
    selectedTags,
    getSelectTagLink,
    getRemoveTagLink,
    clearSelectedTagsLink,
    getPageLink,
    nextPageLink,
    previousPageLink,
    areFiltersActive
  }
}

export type ArticleFilters = ReturnType<typeof useArticleFilters>
